import React from 'react';
import { Navigate } from 'react-router-dom';

const NotFoundRedirect = () => <Navigate replace to="/404" />;

export default NotFoundRedirect;
